import { Link } from "react-router-dom";
import { Sparkles, PenLine } from "lucide-react";

// V1: Member Stories are HIDDEN until real testimonials exist (FTC / trust).
// This page shows an honest empty state and invites real stories.
export default function SuccessStories() {
  return (
    <div className="mx-auto max-w-2xl px-4 sm:px-6 py-20 text-center" data-testid="success-stories-empty">
      <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-rose/40 text-teal mx-auto">
        <Sparkles className="h-8 w-8" />
      </span>
      <h1 className="mt-6 font-display text-4xl sm:text-5xl text-plum">Success stories, coming soon</h1>
      <p className="mt-4 text-mutedplum text-lg leading-relaxed">
        We're a founding community, so we won't invent testimonials or put words in anyone's mouth.
        The moment real members share their wins, their stories will live right here—in their own words.
      </p>
      <p className="mt-3 text-plum-ink/80">
        Want to be one of the first? Join the Circle, start your journey, and share your story when you're ready.
      </p>
      <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/join" className="rounded-full bg-teal px-7 py-3.5 font-semibold text-white hover:bg-teal-dark transition-colors">Join the Circle</Link>
        <Link to="/community/success-stories" data-testid="share-story-link"
          className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-plum px-7 py-3.5 font-semibold text-plum hover:bg-plum hover:text-cream transition-colors">
          <PenLine className="h-4 w-4" /> Share your story
        </Link>
      </div>
    </div>
  );
}
